export const show404 = () => showError({ status: 404, statusText: 'Page not found' })

export const showRequestError = () => showError({ status: 500, statusText: 'Something went wrong' })

export const isNotFoundError = (err: unknown): boolean =>
  (err as { response?: { status?: number } })?.response?.status === 404
